import React, { useEffect, useState } from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import classes from './comment-pre-built-limited-cart.scss';
export const CommentPreBuiltLimitedCartPopupComponent = ({
  open,
  isProductComment,
  productImageUrl,
  storeName,
  productName,
  itemId,
  onSendMessage,
  onClose
}) => {
  const [note, setNote] = useState('');
  const [disabledSendBtn, setDisabledSendBtn] = useState(false);
  useEffect(() => {
    if (!open) {
      setNote('');
      setDisabledSendBtn(false);
    }
  }, [open]);
  const handleSendMessage = () => {
    if (!note) {
      return;
    }
    setDisabledSendBtn(true);
    onSendMessage(note, itemId);
  };
  const handleChangeNote = e => {
    setDisabledSendBtn(false);
    setNote(e.target.value);
  };
  const renderContent = () => /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentBody
  }, isProductComment && /*#__PURE__*/React.createElement("div", {
    className: classes.logo
  }, /*#__PURE__*/React.createElement("img", {
    src: productImageUrl,
    alt: "productImg"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textAreaBlock
  }, isProductComment && /*#__PURE__*/React.createElement("span", {
    className: classes.productName
  }, "Your message for ", /*#__PURE__*/React.createElement("span", {
    className: classes.name
  }, productName)), /*#__PURE__*/React.createElement("textarea", {
    placeholder: "Leave your note here",
    value: note,
    onChange: handleChangeNote,
    className: classes.textArea
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    textTransform: ButtonTextTransform.none,
    fontSize: ButtonFontSize.small,
    type: ButtonType.fullGrey,
    size: ButtonSize.large,
    className: classes.greyButton,
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    textTransform: ButtonTextTransform.none,
    fontSize: ButtonFontSize.small,
    type: ButtonType.primary,
    size: ButtonSize.large,
    className: classes.button,
    disabled: !note || disabledSendBtn,
    onClick: handleSendMessage
  }, "Send Message")));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    title: `Send a message ${storeName ? `to ${storeName}` : ''}`,
    dataPopup: "CommentPreBuiltLimitedCartPopup",
    titleClasses: classes.header,
    titleHeader: classes.header,
    content: renderContent(),
    contentClass: classes.content,
    popupClassName: classes.popup,
    showCloseButton: true,
    open: open,
    onClose: onClose
  });
};